import {
  LoginModal
} from './components';

import 'antd/dist/antd.css';
import './App.scss';

function App() {

  document.title = process.env.REACT_APP_TITLE;

  return (
    <div className="App">
      <LoginModal />
    </div>
  );
}

export default App;
